import { Offcanvas } from 'react-bootstrap';
import { useProduct } from '../context/ProductProvider';

interface OffProductPriceProps {
    fetchProducts?: (force?: boolean) => Promise<unknown>;
}

const OffProductPrice = (_props: OffProductPriceProps) => {
    const { showPriceProduct, setShowPriceProduct } = useProduct();

    const handleClose = () => {
        setShowPriceProduct(false);
    };

    return (
        <Offcanvas show={showPriceProduct !== false} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Product PRice</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                Some text as placeholder. In real life you can have the elements you have chosen. Like, text, images, lists,
                etc.
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffProductPrice;
